module.exports = __webpack_public_path__ + "static/img/2010.09939cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2010.jpg
// module id = 301
// module chunks = 0